import React from "react";
import FormGroup from "./FormGroup";
import Input from "./Input";
import Checkbox from "./Checkbox";
import DateTime from "./DateTime";
import Select from "./Select";

export default function UsebyDateRangeFormGroup({
  error,
  valid = !error,
  required,
  wrapperClassName,
  daysLimitDisabled = false,
  help,
  disabled,
  readOnly,
  label,
  value: { days_limit = null, starts_at = null, ends_at = null },
  initialValue = {
    starts_at: moment
      .tz(timeZoneName)
      .add(days_limit || 30, "days")
      .format(moment.RUBY_DATETIME_FORMAT),
  },
  onFocus,
  onBlur,
  onChange,
  timeZoneName,
}) {
  const options = [
    ["starts_at", I18n.t("papp.components.UsebyDateRangeFormGroup.starts_at_label")],
    ["ends_at", I18n.t("papp.components.UsebyDateRangeFormGroup.ends_at_label")],
    ["starts_at_and_ends_at", I18n.t("papp.components.UsebyDateRangeFormGroup.starts_at_and_ends_at_label")],
  ];

  if (!daysLimitDisabled) {
    options.push(["days_limit", I18n.t("papp.components.UsebyDateRangeFormGroup.days_limit_label")]);
  }
  let currentOption = null;
  if (days_limit !== null) {
    currentOption = "days_limit";
  } else if (starts_at !== null && ends_at !== null) {
    currentOption = "starts_at_and_ends_at";
  } else if (starts_at !== null) {
    currentOption = "starts_at";
  } else if (ends_at !== null) {
    currentOption = "ends_at";
  }

  const handleSelectChange = (nextOption) => {
    // debugger;
    if (nextOption === "days_limit") {
      onChange({ days_limit: 30 });
    } else if (nextOption === "starts_at") {
      onChange({ starts_at: starts_at || ends_at || moment.tz(timeZoneName).format(moment.RUBY_DATETIME_FORMAT) });
    } else if (nextOption === "ends_at") {
      onChange({
        ends_at:
          ends_at ||
          starts_at ||
          moment
            .tz(timeZoneName)
            .add(days_limit || 30, "days")
            .format(moment.RUBY_DATETIME_FORMAT),
      });
    } else if (nextOption === "starts_at_and_ends_at") {
      onChange({
        starts_at: starts_at || ends_at || moment.tz(timeZoneName).format(moment.RUBY_DATETIME_FORMAT),
        ends_at:
          ends_at ||
          starts_at ||
          moment
            .tz(timeZoneName)
            .add(days_limit || 30, "days")
            .format(moment.RUBY_DATETIME_FORMAT),
      });
    } else {
      onChange({});
    }
  };

  return (
    <FormGroup error={error} valid={valid} required={required} className={wrapperClassName}>
      <Checkbox
        label={label}
        required={required}
        checked={currentOption !== null}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(checked) => onChange(checked ? initialValue : {})}
        toggle
        disabled={disabled}
        readOnly={readOnly}
      />

      <span className="field inline u-marginLeft" style={{ visibility: currentOption === null ? "hidden" : undefined }}>
        <Select
          value={currentOption}
          onChange={handleSelectChange}
          options={options}
          disabled={disabled}
          readOnly={readOnly}
          className="u-smallWidth"
        />

        {currentOption === "days_limit" && (
          <span>
            <Input
              value={days_limit}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={(days_limit) => onChange({ days_limit })}
              type="number"
              min={0}
              disabled={disabled}
              readOnly={readOnly}
              className="u-notSoTinyWidth"
            />
            &nbsp; {I18n.t("papp.components.UsebyDateRangeFormGroup.days_since_order_creation")}
          </span>
        )}

        {(currentOption === "starts_at" || currentOption === "starts_at_and_ends_at") && (
          <span>
            {I18n.t("base.from")} &nbsp;
            <DateTime
              value={starts_at}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={(starts_at) => onChange({ starts_at, ends_at })}
              disabled={disabled}
              readOnly={readOnly}
              className="u-marginRight"
            />
          </span>
        )}

        {(currentOption === "ends_at" || currentOption === "starts_at_and_ends_at") && (
          <span>
            {I18n.t("base.to")} &nbsp;
            <DateTime
              value={ends_at}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={(ends_at) => onChange({ starts_at, ends_at })}
              disabled={disabled}
              readOnly={readOnly}
            />
          </span>
        )}
      </span>

      {!!help && <div className="ui help">{help}</div>}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/UsebyDateRangeFormGroup.jsx